import { v4 } from 'uuid';

import { concatOperators, defaultTypeOperators } from '../constants/filter';

const initialState = {
  clauses: [],
  concatOperator: concatOperators.AND,
  visibility: true,
};

export const createFilterReducer = (prefix, additionalHandlers, additionalInitStateProps = {}) => {
  const ADD_FILTER_CLAUSE = `${prefix}ADD_FILTER_CLAUSE`;
  const COPY_FILTER = `${prefix}COPY_FILTER`;
  const REMOVE_FILTER_CLAUSE = `${prefix}REMOVE_FILTER_CLAUSE`;
  const REMOVE_FILTER = `${prefix}REMOVE_FILTER`;
  const SET_FILTER_CLAUSE_FIELD = `${prefix}SET_FILTER_CLAUSE_FIELD`;
  const SET_FILTER_CLAUSE_VALUE = `${prefix}SET_FILTER_CLAUSE_VALUE`;
  const SET_CLAUSES_CONCAT_OPERATOR = `${prefix}SET_CLAUSES_CONCAT_OPERATOR`;
  const SET_FILTER_CLAUSE_OPERATOR = `${prefix}SET_FILTER_CLAUSE_OPERATOR`;
  const SET_FILTER_VISIBILITY = `${prefix}SET_FILTER_VISIBILITY`;

  const redefinedInitialState = { ...initialState, ...additionalInitStateProps };

  return (state = redefinedInitialState, action) => {
    switch (action.type) {
      case ADD_FILTER_CLAUSE:
        return {
          ...state,
          clauses: [...state.clauses, { id: v4() }],
        };

      case COPY_FILTER:
        return {
          ...state,
          clauses: [...state.clauses, ...action.clauses],
        };

      case SET_FILTER_VISIBILITY:
        return {
          ...state,
          visibility: !state.visibility,
        };

      case REMOVE_FILTER_CLAUSE: {
        const removeClauseIndex = state.clauses.findIndex((p) => p.id === action.id);

        return {
          ...state,
          clauses: [
            ...state.clauses.slice(0, removeClauseIndex),
            ...state.clauses.slice(removeClauseIndex + 1),
          ],
        };
      }

      case REMOVE_FILTER:
        return {
          ...state,
          clauses: [],
          visibility: true,
        };

      case SET_FILTER_CLAUSE_FIELD: {
        const setClauseIndex = state.clauses.findIndex((p) => p.id === action.id);

        return {
          ...state,
          clauses: [
            ...state.clauses.slice(0, setClauseIndex),
            {
              id: state.clauses[setClauseIndex].id,
              field: action.field,
              type: action.fieldType,
              operator: defaultTypeOperators[action.fieldType],
            },
            ...state.clauses.slice(setClauseIndex + 1),
          ],
        };
      }

      case SET_FILTER_CLAUSE_VALUE: {
        const setValueClauseIndex = state.clauses.findIndex((p) => p.id === action.id);

        return {
          ...state,
          clauses: [
            ...state.clauses.slice(0, setValueClauseIndex),
            { ...state.clauses[setValueClauseIndex], value: action.value },
            ...state.clauses.slice(setValueClauseIndex + 1),
          ],
        };
      }

      case SET_CLAUSES_CONCAT_OPERATOR:
        return {
          ...state,
          concatOperator: action.value,
        };

      case SET_FILTER_CLAUSE_OPERATOR: {
        const setOperatorClauseIndex = state.clauses.findIndex((p) => p.id === action.id);
        const clause = state.clauses[setOperatorClauseIndex];

        if (action.resetClauseValue) {
          delete clause.value;
        }

        clause.operator = action.value;

        return {
          ...state,
          clauses: [
            ...state.clauses.slice(0, setOperatorClauseIndex),
            clause,
            ...state.clauses.slice(setOperatorClauseIndex + 1),
          ],
        };
      }

      // no default
    }

    if (additionalHandlers && additionalHandlers[action.type]) {
      return additionalHandlers[action.type](state, action, redefinedInitialState);
    }

    return state;
  };
};

export const getClauses = (state) => state.clauses;

export const getConcatOperator = (state) => state.concatOperator;
